module.exports = __webpack_public_path__ + "static/media/background.518a3860.m4a";